import React from "react";
import "./FourthSection.css";
import { Link } from "react-router-dom";

import project1 from "../../assets/parallax-bg-01.jpg";
import project2 from "../../assets/parallax-bg-01.jpg";
import project3 from "../../assets/parallax-bg-01.jpg";
import project4 from "../../assets/parallax-bg-01.jpg";
import project5 from "../../assets/parallax-bg-01.jpg";
import project6 from "../../assets/parallax-bg-01.jpg";

const FourthSection = () => {
  return (

    <section className="fourth-section">

      <div className="fourth-container">

        {/* TITLE */}

        <h2>Our Projects</h2>

        <p className="fourth-subtitle">
          Glimpse of Our Latest Work
        </p>

        {/* GRID */}

        <div className="projects-grid">

          {/* CARD 1 */}

          <div className="project-card">

            <img src={project1} alt="Solar Power Plant" />

            <div className="project-overlay">

              <h3>Solar Power Plant</h3>

              <p>Category: Renewable Energy</p>

            </div>

          </div>

          {/* CARD 2 */}

          <div className="project-card">

            <img src={project2} alt="Transmission Line" />

            <div className="project-overlay">

              <h3>132kV Transmission Line</h3>

              <p>Category: T&D</p>

            </div>

          </div>

          {/* CARD 3 */}

          <div className="project-card">

            <img src={project3} alt="Substation" />

            <div className="project-overlay">

              <h3>33/11kV Substation</h3>

              <p>Category: EPC</p>

            </div>

          </div>

          {/* CARD 4 */}

          <div className="project-card">

            <img src={project4} alt="Solar Farm" />

            <div className="project-overlay">

              <h3>Solar Farm Development</h3>

              <p>Category: Renewable Energy</p>

            </div>

          </div>

          {/* CARD 5 */}

          <div className="project-card">

            <img src={project5} alt="Industrial EPC" />

            <div className="project-overlay">

              <h3>Industrial EPC</h3>

              <p>Category: Industrial</p>

            </div>

          </div>

          {/* CARD 6 */}

          <div className="project-card">

            <img src={project6} alt="Infrastructure Project" />

            <div className="project-overlay">

              <h3>Infrastructure Project</h3>

              <p>Category: Construction</p>

            </div>

          </div>

        </div>

        {/* BUTTON */}

        <div className="view-projects-btn">

<Link to="/projects">
  View All Projects
</Link>

        </div>

      </div>

    </section>
  );
};

export default FourthSection;